import styled from "livemap-ui";

export const SignUpInfo = () => (
  <Text>
    <p>
      By signing up you agree to our{" "}
      <a
        href="https://www.veridict.com/privacy-policy"
        style={{ fontSize: "16px" }}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
    </p>
  </Text>
);

const Text = styled.div`
  * {
    font-size: 16px;
    display: inline-block;
  }

  p {
    opacity: ${(p) => p.theme.disabledOpacity};
  }
`;
